var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrueCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5405 2.56209L9.93005 18.5589C9.78538 18.6987 9.61347 18.8096 9.42418 18.8853C9.2349 18.961 9.03196 19 8.82701 19C8.62206 19 8.41912 18.961 8.22983 18.8853C8.04055 18.8096 7.86864 18.6987 7.72397 18.5589L0.456893 11.5603C0.31204 11.4208 0.197137 11.2552 0.118743 11.0729C0.0403488 10.8906 2.15848e-09 10.6953 0 10.498C-2.15848e-09 10.3007 0.0403488 10.1054 0.118743 9.9231C0.197137 9.74084 0.31204 9.57522 0.456893 9.43572C0.601747 9.29622 0.773712 9.18556 0.962972 9.11006C1.15223 9.03457 1.35508 8.99571 1.55993 8.99571C1.76479 8.99571 1.96763 9.03457 2.15689 9.11006C2.34615 9.18556 2.51812 9.29622 2.66297 9.43572L8.82831 15.3733L24.337 0.440014C24.6296 0.158278 25.0263 0 25.4401 0C25.8538 0 26.2506 0.158278 26.5431 0.440014C26.8356 0.72175 27 1.10387 27 1.5023C27 1.90074 26.8356 2.28285 26.5431 2.56459L26.5405 2.56209Z",
    fill: "#61AF64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueCheck);
export default __webpack_public_path__ + "static/media/trueCheck.b82cd98ab1e1db7711fbb93f52e62fa8.svg";
export { ForwardRef as ReactComponent };